import {Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, signal, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {HttpStatusCode} from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";
import {CustomMessageService, LocalStorageService, ResponseHttpError, ResponseHttpSuccess, UtilService, CountdownTimerService, CountdownTick} from 'library';
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import { faPenNib } from '@fortawesome/free-solid-svg-icons';
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import {NotificationOtpService} from 'projects/store/src/app/services/api/v1/notification-otp.service';
import {LocalStorageKey, OtpType} from "../../../enums";
import {UserData} from "projects/store/src/app/interfaces";
import {OtpServiceType} from 'projects/store/src/app/enums/otp-service-types.enum'

@Component({
  selector: 'app-sales-credit-bureau',
  templateUrl: './sales-credit-bureau.component.html'
})
export class SalesCreditBureauComponent implements OnDestroy {
  form: FormGroup;
  formCode: FormGroup
  submitted: boolean = false;
  loading: boolean = false;
  requestId: string;
  authorizationHTML: string = '';
  sentCode!: boolean;
  visibleFirstSentCodeMessageModal!: boolean;
  visibleRetriesSentCodeMessageModal!: boolean;
  visibleSigningModal!: boolean;
  visibleErrorIDModal = false;
  visibleSigningManualModal = false;
  visibleCodeModal = false;
  otpType = OtpType.bureau;
  maxRetries = 3;
  currentRetries = 0;
  userData!: UserData;
  faPenNib = faPenNib;
  scrollEl!: HTMLDivElement;
  timeNewCodeSending!: { minutes: number, seconds: number };
  maxTimeToRetry: { minutes: number, seconds: number };
  private countdownSub: any;
  authorizationExpired!: boolean;
  code!: string
  errorMessage!: string;
  request: any;
  messageOtpService!: string;
  messageOtpServiceFirstSend!: string;
  showOtpServiceModal = false;
  selectedOtpService!: string;
  otpServicesOptions: any[] = [];
  otpServiceType: string = '';

  visibleAcceptTermsModal!: boolean;
  readonly categoryCode = this.route.snapshot.params['category_code'];
  data = signal<any>({});

  @Output() nextStepEvent = new EventEmitter();

  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private router: Router,
              private utilService: UtilService,
              private customMessageService: CustomMessageService,
              private localStorageService: LocalStorageService,
              private salesWorkflowService: SalesWorkflowService,
              private notificationOtpService: NotificationOtpService,
              private countdownTimer: CountdownTimerService) {
    this.requestId = this.route.snapshot.params['request_id']
    this.form = new FormGroup({
      code: new FormControl(null, [Validators.required, Validators.minLength(4)])
    });

    this.formCode = new FormGroup({
      document_number: new FormControl('', [Validators.required])
    });
    this.maxTimeToRetry = { minutes: 0, seconds: 20 }
    this.request = this.requestService.request;
    this.userData = localStorageService.get(LocalStorageKey.data);
  }

  ngOnInit() {
    this.check();
    this.showGetOtpOptions();
    this.data.set(this.requestService.request);
  }

  showGetOtpOptions(){
    this.notificationOtpService.get().subscribe({
      next: (resp: any) => {
        this.otpServicesOptions = resp;
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.comunicationError();
      }
    });
    this.selectedOtpService = this.requestService.request['person']?.otp_service ?? this.otpServicesOptions[0].value;
    this.messageOtpService = this.notificationOtpService.getDetailOtp(this.selectedOtpService).message;

  }

  check() {
    this.utilService.enablePageLoading();
    this.requestService.getCreditBureau(this.requestId).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.Ok) {
          this.authorizationExpired = resp.body.data.authorization_expired;
          this.authorizationHTML = resp.body.data.authorization_text
          if(this.authorizationExpired === true) {
            this.visibleAcceptTermsModal = true;
            this.scrollEl = document.querySelector('#agreement-container') as HTMLDivElement;
          }else{
            setTimeout(() => this.onNextStep(), 0);
          }
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    });
  }

  sendCode(isRetry: boolean, otp_service: string) {
    this.utilService.enablePageLoading();
    this.requestService.sendCreditBureauCode(this.requestId, isRetry, otp_service).subscribe({
      next: (resp: any) => {
        this.sentCode = resp.status === HttpStatusCode.NoContent;
        this.startTime();
        if( ! isRetry) {
          this.visibleFirstSentCodeMessageModal = true;
        }else{
          this.visibleSigningModal = true;
        }

        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        if(error.status === HttpStatusCode.NotAcceptable) {
          this.sentCode = false;
          this.startTime();
          this.closeAllModals();
          if( !isRetry) {
            this.visibleFirstSentCodeMessageModal = true;
          }else{
            this.visibleRetriesSentCodeMessageModal = true;
          }
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
        this.utilService.disablePageLoading();
      }
    });
  }

  authorize() {
    this.submitted = true;
    if(this.form.invalid) {
      return;
    }

    this.utilService.enablePageLoading();
    this.requestService.checkCreditBureauCode(this.requestId, this.form.value.code).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.Ok) {
          this.onNextStep()
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
      },
      error: (error: ResponseHttpError) => {
        if(error.status === HttpStatusCode.NotAcceptable) {
          this.form.controls['code'].setErrors({ invalid: true});
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
        this.utilService.disablePageLoading();
      }
    });
  }

  onSearchCode(){

    this.loading = true;
    this.submitted = true;

    if(this.formCode.invalid) {
      this.formCode.markAllAsTouched();
      this.loading = false;
      return;
    }
    const data = {
      document_number: this.formCode.get('document_number')?.value,
      type: this.otpType
    }

    this.requestService.getCode(this.requestId, data).subscribe({
      next: (resp) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.code = resp.body?.data?.code || null;
          this.visibleSigningManualModal = true;
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }

        this.loading = false;
        this.submitted = false;
      },
      error: (error: ResponseHttpError) => {
        if (error.status === HttpStatusCode.NotAcceptable) {
          this.visibleErrorIDModal = true;
        }else{
          this.customMessageService.responseNoticeHandler(error);
          this.loading = false;
        }
      }
    })

  }

  // El cálculo y actualización del tiempo se movió al CountdownTimerService
  // Se mantiene este método eliminado para usar el servicio.

  // Inicia el conteo usando el servicio de la librería
  startTime() {
    this.timeNewCodeSending = { ...this.maxTimeToRetry };

    // Cancelar suscripción previa si existiera
    this.countdownSub?.unsubscribe?.();

    // Iniciar servicio con la duración configurada
    this.countdownTimer.startWithDuration(this.maxTimeToRetry);

    // Suscribirnos a los ticks para reflejar el tiempo en el componente
    this.countdownSub = this.countdownTimer.tick$.subscribe((tick: CountdownTick) => {
      this.timeNewCodeSending = { ...tick };
    });
  }

  showModal(){
    this.visibleSigningModal = false;
    this.visibleFirstSentCodeMessageModal =false;
    this.visibleCodeModal = true;
  }

  onRetryID() {
    this.visibleErrorIDModal = false;
    this.loading = false;
    this.visibleCodeModal = true;
  }

  timeFinished() {
    return this.timeNewCodeSending && this.timeNewCodeSending.minutes==0 && this.timeNewCodeSending.seconds==0;
  }

  get f() {
    return this.form.controls;
  }

  get fc() {
    return this.formCode.controls;
  }


  acceptLoanTerms() {
    this.visibleAcceptTermsModal = false;
    this.otpServiceType = this.request.person.otp_service?? OtpServiceType.WHATSAPP;
    this.messageOtpServiceFirstSend = this.builtMsgSendFirstCode()
    this.sendCode(false, this.otpServiceType);
  }

  notAcceptLoanTerms() {
    this.router.navigate([this.salesWorkflowService.getErrorNotApprovedRequestUrl()])
    this.utilService.disablePageLoading()
  }

  // TODO repetido de siging, pasar a la libreria
  isTheEndOfAgreement() {
    let limit = Math.ceil(this.scrollEl?.scrollHeight - (this.scrollEl?.scrollHeight * 0.02));
    let current = Math.ceil(this.scrollEl?.scrollTop) + this.scrollEl?.clientHeight;
    return current >= limit;
  }

  onSelectedOtpServiceAndSend(flag:boolean){

    this.showOtpServiceModal = false;

    const otp_service: string = this.selectedOtpService ?? '';
    this.messageOtpService = this.notificationOtpService.getDetailOtp(this.selectedOtpService ?? '').message;

    this.sendCode(flag, otp_service);

  }

  showOptionesSend(){
    this.visibleSigningModal = false;
    this.showOtpServiceModal = true;
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  getCanCancelRequest(): boolean {
    return this.salesWorkflowService.canCancelRequest();
  }

  viewValidateButtonWithDocument() {
    return this.userData?.store.setting.enabled_view_otp_by_document ?? true;
  }

  builtMsgSendFirstCode(): string {
    switch (this.otpServiceType) {
      case OtpServiceType.WHATSAPP:
        return `Hemos enviado un <strong>WhatsApp</strong> a tu teléfono.`;
      case OtpServiceType.LLAMADA:
        return `Vamos a realizar una <strong>LLAMADA</strong> a tu teléfono.`;
      case OtpServiceType.SMS:
      default:
        return `Hemos enviado un <strong>SMS</strong> a tu teléfono.`;
    }
  }

  closeAllModals() {
    this.visibleSigningModal = false;
    this.visibleFirstSentCodeMessageModal = false;
    this.visibleRetriesSentCodeMessageModal = false;
  }

  ngOnDestroy() {
    this.countdownSub?.unsubscribe?.();
    // Asegurar detener el servicio si el componente se destruye durante un conteo
    this.countdownTimer.stop();
  }
}
